import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { PortDepartures } from '../interfaces/mock.interface';
import { format } from 'date-fns';
import { ro } from 'date-fns/locale';
import { Ship, Calendar } from 'lucide-react';

interface VesselDeparturesWidgetProps {
  portsDepartures: PortDepartures[];
  maxRows?: number;
}

export const VesselDeparturesWidget = ({
  portsDepartures,
  maxRows = 10,
}: VesselDeparturesWidgetProps) => {
  if (portsDepartures.length === 0) {
    return (
      <Card className="w-full h-full flex flex-col">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Ship className="h-5 w-5" />
            Plecări Nave din Porturi
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center py-8">
            Nu există plecări programate.
          </p>
        </CardContent>
      </Card>
    );
  }

  // Flatten all departures into a single array and limit to maxRows
  const allDepartures = portsDepartures
    .flatMap(portData =>
      portData.departures.map(departure => ({
        ...departure,
        portCode: portData.portCode,
        portName: portData.portName,
      }))
    )
    .slice(0, maxRows);

  return (
    <Card className="w-full h-full flex flex-col">
      <CardHeader className="flex-shrink-0">
        <CardTitle className="flex items-center gap-2">
          <Ship className="h-5 w-5" />
          Plecări Nave din Porturi Top
        </CardTitle>
        <p className="text-sm text-muted-foreground">
          Următoarele {maxRows} plecări (peste 5 zile)
        </p>
      </CardHeader>
      <CardContent className="flex-1 flex flex-col">
        <div className="rounded-md border flex-1 overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Navă</TableHead>
                <TableHead>Port</TableHead>
                <TableHead>ETD</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {allDepartures.map((departure, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <div className="flex flex-col">
                      <span className="font-medium text-sm">
                        {departure.vesselName}
                      </span>
                      <span className="text-xs text-muted-foreground font-mono">
                        {departure.vesselCode}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline" className="font-mono text-xs">
                      {departure.portCode}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-1 text-xs">
                      <Calendar className="h-3 w-3 text-muted-foreground" />
                      {format(new Date(departure.etd), 'dd MMM', {
                        locale: ro,
                      })}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};
